module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "daterangefield"
  }, [_vm._v("\n  " + _vm._s(_vm._f("date")(_vm.data, _vm.config.decoratorOptions.format.toUpperCase())) + " -\n  " + _vm._s(_vm._f("date")(_vm.endDate, _vm.config.decoratorOptions.format.toUpperCase())) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c9a4931"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldDateRange.vue
// module id = 680
// module chunks = 0